// extracted by mini-css-extract-plugin
export default {"tags":"ecryH","tag":"_LlEf","error":"bVZD2"};